module.exports = __webpack_public_path__ + "img/xzld.62a8d9a1.png";